<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="bsd-section">
          <breadcrumb />
        </div>

        <div class="z-title z-title--small spacer-bottom-l">
          Meus dados
        </div>

        <div class="z-title z-title--micro spacer-bottom-st">
          Dados Pessoais
        </div>

        <alert-box ref="alertBox" class="spacer-bottom-l" />

        <div class="row">
          <div class="col-md-6 form-group">
            <input-field
              label="Nome"
              v-model.trim="student.name"
              disabled
            />
          </div>

          <div class="col-md-6 form-group">
            <input-field
              label="CPF"
              v-model.trim="student.cpf"
              disabled
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 form-group">
            <input-field
              label="Email"
              v-model.trim="student.email"
            />
          </div>

          <div class="col-md-6 form-group--no-margin">
            <div class="row">
              <div class="col-md-6 form-group form-group--no-margin-md">
                <input-field
                  label="Telefone"
                  v-model.trim="student.formatted_cellphone"
                  :error-message="errors.cellphone"
                  v-mask="['(##) ####-####', '(##) #####-####']"
                />
              </div>

              <div class="col-md-6 form-group form-group--no-margin-md">
                <input-field
                  label="Sexo"
                  v-model.trim="student.gender"
                  disabled
                />
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 form-group">
            <input-field
              label="Data de nascimento"
              v-model.trim="student.birthday"
              v-mask="'##/##/####'"
            />
          </div>

          <div class="col-md-6 form-group">
            <div class="row">
              <div class="col-md-6 form-group form-group--no-margin-md">
                <input-field
                  label="RG"
                  v-model.trim="student.identity_card"
                  disabled
                />
              </div>

              <div class="col-md-6 form-group form-group--no-margin">
                <input-field
                  label="Orgão Emissor"
                  v-model.trim="student.identity_card_emissor"
                  disabled
                />
              </div>
            </div>
          </div>
        </div>

        <div class="z-divider z-divider--light"></div>

        <div class="z-title z-title--micro spacer-st">
          Endereço
        </div>

        <div class="row">
          <div class="col-md-6 form-group">
            <input-field
              label="CEP"
              v-model.trim="student.postal_code"
              v-mask="'#####-###'"
              @blur="loadAddress"
            />
          </div>

          <div class="col-md-6 form-group">
            <input-field
              label="Rua"
              v-model.trim="student.address"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 form-group">
            <input-field
              label="Cidade"
              v-model.trim="student.city"
              disabled
            />
          </div>

          <div class="col-md-6 form-group form-group--no-margin">
            <div class="row">
              <div class="col-md-6 form-group">
                <input-field
                  label="Número"
                  v-model.trim="student.address_number"
                />
              </div>

              <div class="col-md-6 form-group form-group--no-margin-md">
                <input-field
                  label="Complemento"
                  v-model.trim="student.address_complement"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 form-group">
            <input-field
              label="Estado"
              v-model.trim="student.state"
              disabled
            />
          </div>
        </div>
        <button
          class="z-button z-button--primary z-button--block spacer-bottom-xl"
          @click="updateStudent"
        >
          Alterar dados
        </button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.form-group {
  margin-bottom: var(--space-large);
  position: relative;
}

.form-group--no-margin {
  margin: 0;
}

.form-group--no-margin-md {
  @media screen and (min-width: $screen-md-min) {
    margin: 0;
  }
}

</style>

<script>
import AlertBox from 'components/zilla/alert-box';
import { mapState, mapActions } from 'vuex';
import Breadcrumb from 'components/breadcrumb';
import InputField from 'components/zilla/input-field';
import CurrentStudentService from 'services/CurrentStudentService';

export default {
  components: {
    AlertBox,
    Breadcrumb,
    InputField,
  },
  computed: {
    ...mapState([
      'student',
    ]),
  },
  data() {
    return {
      errors: {
        cellphone: '',
      },
    };
  },
  mounted() {
    this.$tracker.logEvent('Viewed Personal Data Page');
  },
  methods: {
    ...mapActions([
      'loadStudent',
    ]),

    updateStudent() {
      this.$tracker.logEvent('[Profile] Clicked "Alterar dados"');
      this.$pageLoader.show('Alterando dados.');

      this.$gambit.trackInteraction({
        name: 'profile button clicked',
        interactionType: 'button_click',
        visitHash: sessionStorage.getItem('visitHash'),
      });

      if (!this.validateCellphone()) {
        this.$pageLoader.hide();
        this.errors.cellphone = 'Telefone inválido';
        return false;
      }

      const studentDataUpdated = {
        address: this.student.address,
        address_complement: this.student.address_complement,
        address_number: this.student.address_number,
        birthday: this.student.birthday,
        city_id: this.student.city_id,
        cellphone: this.student.formatted_cellphone,
        email: this.student.email,
        postal_code: this.student.postal_code,
        state_id: this.student.state_id,
      };

      return CurrentStudentService.update(studentDataUpdated)
        .then(() => {
          this.loadStudent();
          this.$router.push({ name: 'profile-confirmation' });
        })
        .catch(() => {
          this.$refs.alertBox.show(
            'danger', 'Erro inesperado',
            'Houve um problema ao alterar os dados.',
          );
        })
        .finally(() => this.$pageLoader.hide());
    },

    validateCellphone() {
      const cellphoneLength = this.student.formatted_cellphone.replace(new RegExp('\\D', 'g'), '').length;
      return (cellphoneLength === 10 || cellphoneLength === 11);
    },

    loadAddress() {
      /* eslint-disable camelcase */
      return CurrentStudentService.loadAddress(this.student.postal_code)
        .then((request) => {
          if (request.response) {
            const {
              cidade, estado, endereco, state_id, city_id,
            } = request.response;

            this.student.city = cidade;
            this.student.state = estado;
            this.student.address = endereco;
            this.student.city_id = city_id;
            this.student.state_id = state_id;
          }
        });
    },
  },
};
</script>
